import { render, staticRenderFns } from "./Edit_account.vue?vue&type=template&id=2ac5b440&scoped=true&"
import script from "./Edit_account.vue?vue&type=script&lang=js&"
export * from "./Edit_account.vue?vue&type=script&lang=js&"
import style0 from "./Edit_account.vue?vue&type=style&index=0&id=2ac5b440&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac5b440",
  null
  
)

export default component.exports